<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-30 17:53:30
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Shift\ShiftTypeMapping\components\editShiftTypeMapping.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-19 13:48:13
-->
<template>
  <normalDialog
    :dialog="show"
    :title="
      view
        ? $t('label_essweb_shiftTypeMapping_dialog_viewShiftTypeMappingTitle')
        : $t('label_essweb_shiftTypeMapping_dialog_editShiftTypeMappingTitle')
    "
    @close="closeDialog"
    width="680"
    maxWidth="680"
  >
    <template v-slot:content>
      <v-form ref="form">
        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
          <AutoComplete
            isRequired
            v-model="curuuid"
            :items="selectStaff"
            label="label_essweb_shiftTypeMapping_dialog_staffNameLabel"
            item-text="preferred_name"
            item-value="uuid"
            :append-icon="!view ? 'arrow_drop_down' : ''"
            disabled
            avatar
            readonly
            chips
            two-line
            :filled="!view"
          >
            <template v-slot:selection.avatar="{ data }">
              <StaffAvatar
                size="36"
                :src="data.item.staff_avatar"
                left
                :staff_name="data.item.preferred_name"
              />
            </template>
            <template v-slot:selection="{ data }">
              {{ $getCommonLangValue(data.item.preferred_name) }}
            </template>
          </AutoComplete>
        </v-col>
        <v-col xs="12" sm="12" md="12" lg="12" cols="12">
          <AutoComplete
            isRequired
            :items="ShiftTypeList"
            label="label_essweb_shiftTypeMapping_dialog_staffTypeLabel"
            item-text="shift_type_name"
            item-value="uuid"
            small-chips
            chips
            :filled="!view"
            :readonly="view"
            :append-icon="!view ? 'arrow_drop_down' : ''"
            deletable-chips
            v-model="selectType"
            multiple
            :rules="$GetRules(['_Require_ArrRules'], [null])"
          >
          </AutoComplete>
        </v-col>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn @save="onEdit" @cancel="closeDialog" v-if="!view" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editShiftTypeMapping",
  computed: {
    ...mapGetters(["companyLang"]),
  },
  props: {
    view: { default: false, type: Boolean },
    show: { default: false, type: Boolean },
    curUuid: { default: "", type: String },
  },
  data() {
    return {
      StaffList: [],
      selectStaff: [],
      curuuid: null,
      ShiftTypeList: [],
      selectType: [],
    };
  },
  watch: {
    curUuid(val) {
      this.curuuid = val;
      if (val) {
        this.getDetail(val);
      }
    },
    show(val) {
      if (!val) {
        this.selectStaff = [];
        this.selectType = [];
        if (this.$refs["form"]) this.$refs["form"].reset();
      }
    },
  },
  mounted() {
    // this.getStaff();
    this.getType();
  },
  methods: {
    removeType: function (item) {
      const index = this.selectType.indexOf(item.uuid);
      if (index >= 0) this.selectType.splice(index, 1);
    },
    getType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_type",
        url: "/shift-type/get-shift-type-list/",
      }).then((res) => {
        res.data.map((item) => {
          item.shift_type_name = that.$getCommonLangValue(item.shift_type_name);
        });
        that.ShiftTypeList = res.data;
      });
    },
    getDetail: function (uuid) {
      const that = this;
      that.selectStaff = [];
      that.selectType = [];
      this.$Request({
        method: "POST",
        table: "ess_att_map_staff_shift_type",
        url: "/shift-type-mapping/get-shift-type-mapping-details/",
        data: {
          uuid: uuid,
        },
      }).then((res) => {
        res.data.map((item) => {
          that.selectType.push(item.shift_type_uuid);
        });
        that.selectStaff.push({
          uuid: res.data[0]["staff_uuid"],
          preferred_name: res.data[0]["preferred_name"],
          staff_avatar: res.data[0]["staff_avatar"],
        });
      });
    },
    closeDialog: function () {
      this.$emit("close");
    },

    onEdit: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onEdit", {
        selectStaff: this.selectStaff,
        selectType: this.selectType.length ? this.selectType.join(",") : "",
      });
    },
  },
};
</script>
